import { Components } from '@mui/material'

export function OverridedTooltip(): Components {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 11,
        },
      },
    },
  }
}
